import { track } from "@amplitude/analytics-browser";
import { useCallback } from "react";

const isProduction = process.env.NODE_ENV === "production";

export const useAmplitudeTracking = () => {
  return useCallback(amplitudeTracking, []);
};

// we have some events that exist outside of a React component
export const amplitudeTracking = (
  eventName: string,
  eventProperties?: Record<string, string>
) => {
  const finalProps = {
    ...eventProperties,
    source: "web",
  };

  if (isProduction) {
    return track(eventName, finalProps);
  } else {
    console.log(`[Amplitude Debug] ${eventName}`, finalProps);

    // Mock object that matches AmplitudeReturn<Result>
    return {
      promise: Promise.resolve({
        event: { event_type: eventName, event_properties: finalProps },
        code: 200,
        message: "Mock event tracked successfully (dev mode)",
      }),
    };
  }
};
